import validator from 'validator';

import { HONEYPOT_NAME } from 'components/forms/Honeypot/constants';

type Errors = {
  [key: string]: string;
};

type Validator = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: Record<string, any>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: Record<string, any>,
) => Errors;

export const focusFieldWithError =
  (formId: string) =>
  (errors: Record<string, string>): void => {
    const form = document.getElementById(formId) as HTMLFormElement;
    if (form && form.elements) {
      // TODO: check if it gets form elements
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const field = form.elements[Object.keys(errors)[0]] as HTMLElement;
      if (field) field.focus();
    }
  };

export const requiredFields =
  (...fieldNames: Array<string>): Validator =>
  (fields, props) => {
    const errors: Record<string, string> = {};
    fieldNames.forEach(field => {
      if (!fields[field] || validator.isEmpty(fields[field].trim())) {
        errors[field] = props.t('errors.required');
      }
    });
    return errors;
  };

export const emailFields =
  (...fieldNames: Array<string>): Validator =>
  (fields, props) => {
    const errors: Record<string, string> = {};
    fieldNames.forEach(field => {
      if (fields[field] && !validator.isEmail(fields[field].trim())) {
        errors[field] = props.t('errors.email');
      }
    });
    return errors;
  };

export const matchingFields =
  (
    fieldPairs: {
      [key: string]: string;
    },
    errorMessage = 'errors.passwordsDoNotMatch',
  ): Validator =>
  (fields, props) => {
    const errors: Record<string, string> = {};
    for (const field in fieldPairs) {
      const first = fields[field];
      const paired = fields[fieldPairs[field]];
      if (first && paired && first !== paired) {
        errors[fieldPairs[field]] = props.t(errorMessage);
      }
    }
    return errors;
  };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isSubmitDisabled = (props: Record<string, any>): boolean =>
  props.invalid ||
  props.pristine ||
  props.submitting ||
  Boolean(props.errorMessage);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const validateHoneypot = (fields: Record<string, any>): Errors =>
  fields[HONEYPOT_NAME] && fields[HONEYPOT_NAME].length > 0
    ? { [HONEYPOT_NAME]: 'Fuck you spambot!' }
    : {};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const processHoneypot = (fields: Record<string, any>): void | never => {
  if (fields[HONEYPOT_NAME] && fields[HONEYPOT_NAME].length > 0) {
    throw new Error('Fuck you spambot!');
  }
};

export const validate =
  (...validators: Array<Validator>): Validator =>
  (fields, props) =>
    Object.assign({}, ...validators.map(validator => validator(fields, props)));
